import React from "react";
import { observer } from "mobx-react";
import { CreditTierCreateStore } from "../../store";
import { CreditTierCreateForm } from "./CreditTierCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type CreditTierCreateProps = {
  creditTierCreateStore: CreditTierCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const CreditTierCreate: React.FC<CreditTierCreateProps> = observer(
  ({ creditTierCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={creditTierCreateStore.isSaving} />
        <CreditTierCreateForm
          creditTierCreateStore={creditTierCreateStore}
          name_esError={creditTierCreateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            creditTierCreateStore.setName_esValue(value);
          }}
          name_es={creditTierCreateStore.entityValues.name_es}
          name_enError={creditTierCreateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            creditTierCreateStore.setName_enValue(value);
          }}
          name_en={creditTierCreateStore.entityValues.name_en}
          name_ptError={creditTierCreateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            creditTierCreateStore.setName_ptValue(value);
          }}
          name_pt={creditTierCreateStore.entityValues.name_pt}
          monthlyCreditsError={
            creditTierCreateStore.errors.monthlyCredits?.message
          }
          onMonthlyCreditsChange={(value: number) => {
            creditTierCreateStore.setMonthlyCreditsValue(value);
          }}
          monthlyCredits={creditTierCreateStore.entityValues.monthlyCredits}
          pricePerCreditError={
            creditTierCreateStore.errors.pricePerCredit?.message
          }
          onPricePerCreditChange={(value: number) => {
            creditTierCreateStore.setPricePerCreditValue(value);
          }}
          pricePerCredit={creditTierCreateStore.entityValues.pricePerCredit}
          pricePerExtraCreditError={
            creditTierCreateStore.errors.pricePerExtraCredit?.message
          }
          onPricePerExtraCreditChange={(value: number) => {
            creditTierCreateStore.setPricePerExtraCreditValue(value);
          }}
          pricePerExtraCredit={
            creditTierCreateStore.entityValues.pricePerExtraCredit
          }
          description_esError={
            creditTierCreateStore.errors.description_es?.message
          }
          onDescription_esChange={(value: string) => {
            creditTierCreateStore.setDescription_esValue(value);
          }}
          description_es={creditTierCreateStore.entityValues.description_es}
          description_enError={
            creditTierCreateStore.errors.description_en?.message
          }
          onDescription_enChange={(value: string) => {
            creditTierCreateStore.setDescription_enValue(value);
          }}
          description_en={creditTierCreateStore.entityValues.description_en}
          description_ptError={
            creditTierCreateStore.errors.description_pt?.message
          }
          onDescription_ptChange={(value: string) => {
            creditTierCreateStore.setDescription_ptValue(value);
          }}
          description_pt={creditTierCreateStore.entityValues.description_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={creditTierCreateStore.isProcessing}
          onSave={() => creditTierCreateStore.saveNewCreditTier()}
          onCancel={() => creditTierCreateStore.cancelNewCreditTier()}
        />
        <ErrorDialog
          open={creditTierCreateStore.errorDialogOpened}
          title={creditTierCreateStore.errorTitle}
          description={creditTierCreateStore.errorDescription}
          onClose={() => creditTierCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
